export default __webpack_public_path__ + "static/media/p2p-hover.04c19605.webp";